// React
import React, { useMemo } from 'react';

// Src
import useDynamicScript from './hooks/useDynamicScript';
import { loadComponent } from './utils/loadComponent';
import { store } from '@/infrastructure/redux/configureStore';
// import { PluginsContext, RemoteConfig } from './Types/PluginsContext';
import ErrorBoundary from './ErrorBoundary';
import PageLoader from '@/application/components/PageLoader/PageLoader';

// Types
export type PluginsContext = {
    anchorNames: string;
    entityTypeName?: string;
    entityId?: number;
    domain?: string;
};

export type RemoteConfig = {
    url: string;
    scope: string;
    module: string;
};

export type PluginsConfig = {
    anchor: string;
    roles: string[];
    anchorConfig: Record<string, string | number>;
    remoteConfig: RemoteConfig;
};

type Props = {
    config: RemoteConfig;
    context: PluginsContext;
};

const CURRENT_TIME = Date.now();

const PluginsLoader: React.FC<Props> = (props) => {
    // Hooks
    const { ready, failed } = useDynamicScript({ url: `${props.config.url}?t=${CURRENT_TIME}` });

    // Helpers
    const Component = useMemo(() => React.lazy(loadComponent(props.config.scope, props.config.module)), [props.config.scope, props.config.module]);

    // Render
    const renderError = (): JSX.Element => <span>Error!</span>;

    const renderLoading = (): JSX.Element => <PageLoader />;

    return (
        <ErrorBoundary>
            {ready && !failed ? (
                <Component
                    store={store}
                    context={props.context}
                />
            ) : failed ? (
                renderError()
            ) : (
                renderLoading()
            )}
        </ErrorBoundary>
    );
};

export default PluginsLoader;
